import React from "react";
import { logs } from "./logsData";

const Logs: React.FC = () => {
    const useScrollToTop = () => {
      React.useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    }
    useScrollToTop();
  return (
    <div className="min-h-screen bg-gray-100 py-12 px-6">
      <div className="max-w-4xl mx-auto text-gray-800">
        <h1 className="text-3xl font-bold mb-8 text-center">Update Logs</h1>

        <div className="space-y-6">
          {logs.map((log) => (
            <div
              key={log.id}
              className="relative bg-white p-6 rounded-lg shadow-md border border-gray-200"
            >
              {/* Date in top-right */}
              <p className="absolute top-4 right-4 text-sm text-gray-400">
                {log.date}
              </p>

              {/* Title */}
              <h2 className="text-xl font-semibold mb-4">{log.title}</h2>

              {/* Description */}
              <p className="text-gray-700">{log.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Logs;
